module.exports = __webpack_public_path__ + "static/media/studiovinari.696eb234.svg";